import { useMemo } from 'react';
import { SetTerminology } from 'api/models/Users';
import { useLocationSetting } from './useLocationSetting';

export const useSetTerminologySetting = () => {
  const {
    value: setTerminologySetting,
    setValue: setSetTerminologySetting,
    isLoading,
    canUpdate,
  } = useLocationSetting<SetTerminology>('set_terminology', SetTerminology.Set, {
    errorLabel: 'Set/Caddy terminology',
  });

  return useMemo(
    () => ({ setTerminologySetting, setSetTerminologySetting, isLoading, canUpdate }),
    [setTerminologySetting, setSetTerminologySetting, isLoading, canUpdate],
  );
};
